module.exports = __webpack_public_path__ + "img/lawOffice-2.33bdbdc6.png";